import React, { useState, useEffect } from "react";
import {SinhalaData, EnglishData, TamilData} from  "./../../../../dummyData/handbookDummyData";
import { useSelector } from "react-redux";


const Chapter1 = () => {
    const selectedLanguage = useSelector((state) => state.language.language);
  const [language, setLanguage] = useState(SinhalaData[0]);

    useEffect(() => {
        switch (selectedLanguage.value) {
          case "english":
            setLanguage(EnglishData[0]);
            break;
          case "tamil":
            setLanguage(TamilData[0]);
            break;
          default:
            setLanguage(SinhalaData[0]);
            break;
        }
      }, [selectedLanguage]);
    

    return (
        <>
            

            {/* Chapter 1 */}

            <section id="section1" className="drivers-handbook-section">
                
                <h2 className="drivers-handbook-heading">
                    {language.chapter1Title}
                </h2>

                <p className="drivers-handbook-paragraph">
                    {language.paragraph1}
                </p>

                <h3 className="drivers-handbook-subheading">
                    {language.subheading1}
                </h3>
                <p className="drivers-handbook-paragraph">
                    {language.paragraph2}

                </p>
                <p className="drivers-handbook-paragraph">
                    {language.paragraph3}
                </p>
                <p className="drivers-handbook-paragraph">
                    {language.paragraph4}
                </p>

                <h3 className="drivers-handbook-subheading">{language.subheading2}</h3>
                <p className="drivers-handbook-paragraph">
                   {language.paragraph5}
                </p>

                <h3 className="drivers-handbook-subheading">{language.subheading3}</h3>
                <p className="drivers-handbook-paragraph">
                     {language.paragraph6}
                </p>
                <p className="drivers-handbook-paragraph">
                     {language.paragraph7}
                </p>

                <h3 className="drivers-handbook-subheading">{language.subheading4}</h3>
                <p className="drivers-handbook-paragraph">
                    {language.paragraph8}
                </p>
                <p className="drivers-handbook-paragraph">
                     {language.paragraph9}
                </p>
                <p className="drivers-handbook-paragraph">
                     {language.paragraph10}
                </p>

                <h3 className="drivers-handbook-subheading">
                    {language.subheading5}
                </h3>
                <p className="drivers-handbook-paragraph">
                    {language.paragraph11}
                </p>

                <h3 className="drivers-handbook-subheading">
                   {language.subheading6}
                </h3>
                <p className="drivers-handbook-paragraph">
                    {language.paragraph12}
                </p>
            </section>
        </>
    )

}

export default Chapter1;
